import React from "react";
import styles from "./SampleCard.module.css";
import tkLogo from "../../assets/tk.svg";
import { ORDER_LINK } from "../../constant/links";
import { BsCheck } from "react-icons/bs";

const SampleCard = ({ name, image, subheading }) => {
  return (
    <div className={styles.card}>
      <div className="">
        <div className="d-flex justify-content-center">
          <div
            className={styles.img_wrapper}
            style={{
              background: `url(${image})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "cover",
            }}
          ></div>
        </div>

        <h3 className={styles.crd_title}>{name}</h3>

        <span className={`d-block ${styles.build_time}`}>{subheading}</span>
      </div>
    </div>
  );
};

export default SampleCard;
